const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = { randomUUID };

export { native as default };
//# sourceMappingURL=node_modules-uuid-dist-esm-browser-native.js.map
